module.exports = __webpack_public_path__ + "static/media/arrow-left-up-line.07041aeb.svg";